module.exports = __webpack_public_path__ + "static/media/file-icon.c7c88652.jpg";